import { useSchedules } from "features/schedule/hooks/CRUDSchedule"
import { useSetPageTitle } from "libs/ga"
import NoSchedules from "./NoSchedules"
import ScheduleItem from "./ScheduleItem"
import { generatePath, useNavigate } from "react-router-dom"
import PATHS from "router/paths"
import { ISchedule, ScheduleBackPage } from "model/food/types/schedule.types"
import styled from "styled-components"

const MyScheduleWrapper = styled.div`
  --my-food-top-navigation-height: 46.4px;
  height: calc(100% - var(--my-food-top-navigation-height));
  padding: 0 var(--app-horizontal-padding);
  overflow-y: auto;
`

const MySchedule = () => {
  useSetPageTitle("My Schedule")
  const { schedules, isNoSchedules } = useSchedules()
  const navigate = useNavigate()

  const onGoToScheduleDetails = (schedule: ISchedule) => {
    navigate(
      generatePath(
        PATHS.app.schedule.details + `?from=${ScheduleBackPage.MY_SCHEDULE}`,
        {
          id: schedule.id,
        },
      ),
    )
  }
  return (
    <MyScheduleWrapper>
      {isNoSchedules && <NoSchedules />}

      {schedules.map((schedule) => (
        <ScheduleItem
          key={schedule.id}
          schedule={schedule}
          onGoToDetails={onGoToScheduleDetails}
        />
      ))}
    </MyScheduleWrapper>
  )
}

export default MySchedule
